import { api } from './client';
import type { Organization } from '@/types';

export function listOrgs(): Promise<Organization[]> {
  return api<Organization[]>('/api/orgs');
}

export function createOrg(name: string): Promise<Organization> {
  return api<Organization>('/api/orgs', { method: 'POST', body: { name } });
}
